import RESTAdapter from '@ember-data/adapter/rest';
import { jsonPost } from '@square/dashboard-utilities/utils/xhr';
import { connectHost } from '@square/environment-utils/connect-urls';
import { getCsrfToken } from '@square/dashboard-utilities/utils/csrf';
import moment from 'moment-timezone';
import { hash } from 'rsvp';
const CONNECT_HOST = connectHost(location.host, {
  useSameHost: true
});
const RESOURCE_URL = `//${CONNECT_HOST}/v2/credit-packs`;
const DEFAULT_OPTIONS = {
  headers: {
    'X-CSRF-Token': getCsrfToken()
  }
};
export let SortByDirection = /*#__PURE__*/function (SortByDirection) {
  SortByDirection["Ascending"] = "ASC";
  SortByDirection["Descending"] = "DESC";
  return SortByDirection;
}({});
function sortByExpiration(creditPacks, sortBy) {
  return creditPacks.sort((a, b) => {
    const expirationA = moment(a.validity_ends_at);
    const expirationB = moment(b.validity_ends_at);
    if (expirationA.isBefore(expirationB)) {
      return sortBy === SortByDirection.Ascending ? -1 : 1;
    }
    if (expirationA.isAfter(expirationB)) {
      return sortBy === SortByDirection.Ascending ? 1 : -1;
    }
    return 0;
  });
}
export default class CreditPack extends RESTAdapter {
  query(_store, _type, filter) {
    const searchEndpoint = `${RESOURCE_URL}/search`;
    const query = {
      query: {
        filter
      }
    };

    // Recursive fetch that returns when there are no more CreditPacks to fetch
    async function search(previousResponse, fetchedCreditPacks) {
      // If not initial call and no more CreditPacks to fetch, return all fetched CreditPacks
      if (previousResponse && !previousResponse.cursor) {
        return fetchedCreditPacks;
      }

      // If first call, use original query; otherwise, add cursor from previous response and call again
      const currentFilter = previousResponse ? {
        ...query,
        cursor: previousResponse.cursor
      } : query;
      const response = await jsonPost(searchEndpoint, currentFilter, DEFAULT_OPTIONS);
      const newCreditPacks = response.credit_packs ?? [];

      // Add fetched instances from latest call to all previously fetched instances and invoke search again
      return search(response, sortByExpiration([...fetchedCreditPacks, ...newCreditPacks], filter.sort_by ?? SortByDirection.Ascending));
    }

    // Create and return hash to satisfy RESTAdapter TS definitions
    return hash({
      data: search(null, [])
    }).then(response => response.data);
  }
}